<template>
  <div>
    <!-- BEGIN #header -->
    <div
      id="header"
      class="app-header"
      v-bind:class="{ 'app-header-inverse': appOptions.appHeaderInverse }"
    >
      <!-- BEGIN navbar-header -->
      <div class="navbar-header">
        <button
          type="button"
          class="navbar-mobile-toggler"
          v-on:click="toggleSidebarEndMobile"
          v-if="appOptions.appSidebarTwo"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button>
        <router-link to="/" class="navbar-brand gap-2">
          <router-link to="/app-selector">
            <img :src="appLogoSvg" class="img-fluid" style="max-height: 40px" />
          </router-link>
        </router-link>
        <button
          type="button"
          class="navbar-mobile-toggler"
          v-on:click="toggleTopMenuMobile"
          v-if="appOptions.appTopMenu && !appOptions.appSidebarNone"
        >
          <span class="fa-stack fa-lg text-inverse">
            <i class="far fa-square fa-stack-2x"></i>
            <i class="fa fa-cog fa-stack-1x"></i>
          </span>
        </button>
        <button
          type="button"
          class="navbar-mobile-toggler"
          v-on:click="toggleTopMenuMobile"
          v-if="appOptions.appTopMenu && appOptions.appSidebarNone"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button>
        <button
          type="button"
          class="navbar-mobile-toggler"
          v-on:click="toggleHeaderMegaMenuMobile"
          v-if="appOptions.appHeaderMegaMenu"
        >
          <span class="fa-stack fa-lg text-inverse m-t-2">
            <i class="far fa-square fa-stack-2x"></i>
            <i class="fa fa-cog fa-stack-1x"></i>
          </span>
        </button>
        <button
          type="button"
          class="navbar-mobile-toggler"
          v-on:click="toggleSidebarMobile"
          v-if="!appOptions.appSidebarNone"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button>
      </div>
      <!-- END navbar-header -->

      <!-- BEGIN header-nav -->
      <div class="navbar-nav">
        <new-task
          v-if="
            user && user.role_id == 5 && user.email_verified_at && mode == 1
          "
          class="ms-md-2 me-auto mb-0 mt-0"
        ></new-task>
        <header-mega-menu
          v-if="appOptions.appHeaderMegaMenu"
        ></header-mega-menu>
        <b-nav-item-dropdown
          ref="bellDropdown"
          class="navbar-item"
          menu-class="dropdown-menu media-list"
          right
          toggle-class="navbar-link dropdown-toggle icon"
          no-caret
        >
          <template slot="button-content">
            <i class="fa fa-bell"></i>
            <span class="badge">{{
              notifications.filter((e) => !e.read_at).length
            }}</span>
          </template>
          <div v-if="notifications.length == 0">
            <div class="dropdown-header">ÉRTESÍTÉSEK (0)</div>
            <div class="text-center w-300px py-1"></div>
          </div>
          <div v-else>
            <div class="dropdown-header">
              ÉRTESÍTÉSEK ({{ notifications.filter((e) => !e.read_at).length }})
            </div>
            <div class="text-center w-300px py-1 h-200px overflow-auto">
              <div
                v-for="(notification, id) in notifications"
                :key="id"
                class="dropdown-item media"
                @click="markAsRead(notification.id)"
              >
                <div class="media-left">
                  <i class="fa fa-bell media-object bg-orange"></i>
                </div>
                <div class="media-body text-start text-truncate">
                  <h6
                    class="media-heading"
                    :class="{ 'fw-light': notification.read_at }"
                    :title="notification.title"
                  >
                    {{ notification.title }}
                  </h6>
                  <router-link
                    v-if="notification.path"
                    :to="{
                      path: notification.path,
                      query: { modalToOpen: notification.modal },
                    }"
                    class="btn btn-primary btn-xs mt-1"
                    @click.native="closeDropdown()"
                    >{{ notification.link_title }}
                    <i class="fa fa-chevron-right"></i
                  ></router-link>
                </div>
              </div>
            </div>
            <div class="text-center mt-1">
              <router-link to="/notifications" @click.native="closeDropdown()">
                <i class="fa fa-ellipsis-h fa-2x"></i>
              </router-link>
            </div>
          </div>
        </b-nav-item-dropdown>
        <b-nav-item-dropdown
          right
          menu-class="me-1"
          class="navbar-item navbar-user dropdown m-0"
          toggle-class="navbar-link dropdown-toggle d-flex align-items-center"
          no-caret
        >
          <template
            v-if="user != null && roles !== false"
            slot="button-content"
          >
            <div
              class="image image-icon bg-gray-800 text-gray-200"
              :title="roles.find((r) => r.id == user.role_id).name"
            >
              <i
                :class="roles.find((r) => r.id == user.role_id).icon_class"
              ></i>
            </div>
            <div class="d-none d-md-inline">
              {{ user.name }}
              <b class="caret"></b>
            </div>
          </template>
          <template slot="button-content" v-else>
            <div class="image image-icon bg-gray-800 text-gray-200">
              <i class="fa fa-user"></i>
            </div>
          </template>
          <router-link to="/settings/profile" class="dropdown-item"
            >Profilom</router-link
          >
          <router-link
            to="/notifications"
            class="dropdown-item d-flex align-items-center"
          >
            Értesítések
            <span class="badge bg-info rounded-pill ms-auto pb-4px">{{
              notifications.filter((e) => !e.read_at).length
            }}</span>
          </router-link>
          <a
            href="javascript:;"
            v-if="user != null && user.roles.length > 1"
            class="dropdown-item d-flex align-items-center"
            v-b-modal.role-select-modal
          >
            Jogkör váltás
            <span class="badge bg-warning rounded-pill ms-auto pb-4px"
              ><i class="fa fa-refresh"></i
            ></span>
          </a>
          <b-modal
            size="sm"
            id="role-select-modal"
            hide-footer
            v-if="user != null && roles !== false"
          >
            <template slot="modal-header">
              <h4 class="modal-title">Jogkör váltás</h4>
              <a
                class="btn-close"
                @click="$bvModal.hide('role-select-modal')"
              ></a>
            </template>
            <button
              class="form-control"
              v-for="(role, id) in user.roles"
              :key="id"
              @click="setTemporary(role)"
              :disabled="role == user.role_id"
              :class="role == user.role_id ? 'bg-warning text-white' : ''"
            >
              {{ roles.find((r) => r.id == role).name }}
            </button>
          </b-modal>
          <a
            href="javascript:;"
            class="dropdown-item d-flex align-items-center"
          >
            Sötét mód
            <div class="form-check form-switch ms-auto">
              <input
                class="form-check-input ms-auto"
                type="checkbox"
                v-model="appOptions.appDarkMode"
                :true-value="true"
                :false-value="false"
                @change="toggleDarkMode"
              />
            </div>
          </a>
          <div class="dropdown-divider"></div>
          <a
            href="javascript:;"
            class="dropdown-item d-flex align-items-center"
            @click="logout()"
          >
            Kijelentkezés
            <span class="badge bg-danger rounded-pill ms-auto pb-4px"
              ><i class="fa fa-sign-out-alt"></i
            ></span>
          </a>
        </b-nav-item-dropdown>
        <div
          class="navbar-divider d-none d-md-block"
          v-if="appOptions.appSidebarTwo"
        ></div>
        <div
          class="navbar-item d-none d-md-block"
          v-if="appOptions.appSidebarTwo"
        >
          <a
            href="javascript:;"
            v-on:click="toggleSidebarEnd"
            class="navbar-link icon"
          >
            <i class="fa fa-th"></i>
          </a>
        </div>
      </div>
      <!-- end header navigation right -->
    </div>
    <!-- end #header -->
    <div
      id="no_internet"
      style="
        position: fixed;
        display: none;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 6000;
        cursor: pointer;
      "
    >
      <div
        class="widget bg-red p-20px text-center text-white"
        style="
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          -ms-transform: translate(-50%, -50%);
        "
      >
        <div class="m-b-md">
          <i class="fa fa-wifi fa-4x"></i>
          <h1 class="m-xs"><i class="fa fa-times"></i></h1>
          <h3 class="font-bold no-margins">Hálózati hiba</h3>
          <small>Újrapróbálkozás ({{ timer }})</small>
        </div>
      </div>
    </div>
    <b-modal
      id="system-messages-modal"
      title="Rendszerüzenetek"
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
    >
      <div
        class="alert"
        v-for="message in systemMessages"
        :key="message.id"
        :class="alertClass(message.priority)"
      >
        {{ message.message }}
      </div>
      Az ablak bezárásával tudomásul veszed az üzeneteket. A bezáráshoz kattints
      {{ buttonLabel }} gombra.
      <div class="row mt-2">
        <div class="col-12 col-md-4" v-for="i in 3" :key="i">
          <button class="w-full w-100 btn btn-primary" @click="closeModal(i)">
            {{ i }}
          </button>
        </div>
      </div>
    </b-modal>
    <!-- Full-screen overlay -->
    <div v-if="showOverlay" class="overlay">
      <div class="spinner"></div>
    </div>
  </div>
</template>

<script>
import AppOptions from "../../config/AppOptions.vue";
import HeaderMegaMenu from "./HeaderMegaMenu.vue";
import User from "../../apis/User";
//this is to be able to track the ongoing axio requests
import { hasPendingRequests } from "../../apis/Api";
import Location from "../../apis/Location";
import Position from "../../apis/Position";
import Echo from "laravel-echo";
import axios from "axios";
import NewTask from "../../components/new-task-wizard/NewTask";
axios.defaults.withCredentials = true;

window.Pusher = require("pusher-js");

export default {
  name: "Header",
  components: {
    HeaderMegaMenu,
    NewTask,
  },
  data() {
    return {
      showOverlay: false,
      // 5 * 60 * 1000
      timeoutInMS: 3600000,
      timeoutId: false,
      roles: false,
      connection: navigator.onLine,
      appOptions: AppOptions,
      notifications: [],
      timer: 3,
      systemMessages: [],
      randomIntForClose: 0,
      buttonLabels: [
        { number: 1, label: "az egyes" },
        { number: 2, label: "a kettes" },
        { number: 3, label: "a hármas" },
      ],
    };
  },
  computed: {
    auth() {
      return this.$store.state.auth;
    },
    user() {
      return this.$store.state.user;
    },
    online() {
      return this.$store.state.online;
    },
    mode() {
      return this.$store.state.mode;
    },
    appModes() {
      return this.$store.state.appModes;
    },
    appLogoSvg() {
      const selectedMode = this.appModes.find(
        (item) => item.mode === this.mode
      );

      // If mode is found, dynamically load the image from the assets folder
      if (selectedMode) {
        return require(`@/assets/img/${selectedMode.logo}`);
      }

      return require(`@/assets/img/${selectedMode.logo}`);
    },
    darkModeEnabled() {
      return document.body.classList.contains("dark-mode");
    },
    buttonLabel() {
      let label = this.buttonLabels.find(
        (e) => e.number == this.randomIntForClose
      );
      if (label) {
        return label.label;
      }
      return "";
    },
  },
  watch: {
    auth(auth) {
      if (auth == false) {
        this.logout();
      }
    },
    online(online) {
      if (online) {
        document.getElementById("no_internet").style.display = "none";
      } else {
        document.getElementById("no_internet").style.display = "block"; //block
        this.interval = setInterval(() => {
          if (this.timer === 0) {
            clearInterval(this.interval);
            window.location.reload();
          } else {
            this.timer--;
          }
        }, 1000);
      }
    },
  },
  created() {
    if (localStorage.getItem("darkmode") == "true") {
      this.appOptions.appDarkMode = true;
    }

    this.roles = JSON.parse(localStorage.getItem("constants")).roles;

    User.auth().then((response) => {
      this.$store.commit("updateUser", response.data);
      localStorage.setItem("user", JSON.stringify(response.data));

      /* 				if (!response.data.email_verified_at) {
					this.$router.push('/settings/profile');
				}
 */
      User.bellNotifications().then((response) => {
        this.notifications = response.data;
      });

      User.systemMessages()
        .then((response) => {
          this.systemMessages = response.data;
        })
        .then(() => {
          if (this.systemMessages.length > 0) {
            this.randomIntForClose = this.getRandomInt(1, 3);
            this.$bvModal.show("system-messages-modal");
          }
        });

      /* ITT INICIALIZÁLJUK A KÉSŐBB A TÖBBI HELYEN HASZNÁLT WEBSOCKET CONNECTIONT */

      window.Echo = new Echo({
        broadcaster: "pusher",
        cluster: process.env.VUE_APP_MIX_PUSHER_APP_CLUSTER,
        encrypted: true,
        key: process.env.VUE_APP_MIX_PUSHER_APP_KEY,
        //authorizer: (channel, options) => {
        authorizer: (channel) => {
          return {
            authorize: (socketId, callback) => {
              axios
                .post(process.env.VUE_APP_BACK_URL + "/api/broadcasting/auth", {
                  socket_id: socketId,
                  channel_name: channel.name,
                })
                .then((response) => {
                  callback(false, response.data);
                })
                .catch((error) => {
                  callback(true, error);
                });
            },
          };
        },
      });

      this.$emit("websocket-set-up-complete");

      window.Echo.private("App.User." + response.data.id)
        /* eslint-disable-next-line no-useless-escape */
        .listen(
          ".Illuminate\\Notifications\\Events\\BroadcastNotificationCreated",
          (e) => {
            //Kornél - töröltem, mert egyelőre nem látom értelmét a type alapú megkülönböztetésnek,mert mindegyik notification-re ugyanazt csináljuk: hozzáadjuk a this.notificationshöz
            //if(e.type == "TaskAcceptedByOperator" || e.type == "TaskUpdatedByLocationLeader"){
            this.notifications.unshift(e);
            //}
          }
        )
        .listen("NotificationRead", (e) => {
          this.notifications.find((n) => n.id == e.id).read_at = true;
        });

      window.Echo.private("App.Service")
        .listen("PositionsUpdated", () => {
          this.getPositions();
        })
        .listen("LocationsUpdated", () => {
          this.getLocations();
        });

      //itt kapja a notiofication ugyanannak a böngészőnek a többi tabja, hogy léptessen ki.

      window.Echo.channel(
        "logout." + localStorage.getItem("browser_session_id")
      ).listen("UserLoggedOut", () => {
        localStorage.removeItem("browser_session_id"); // Clean session ID
        
        //get the value of logoutInProgressInCurrentTab from the store
        const logoutInProgressInCurrentTab = this.$store.state.logoutInProgressInCurrentTab;

        if(logoutInProgressInCurrentTab){
          return;
        }

        this.$nextTick(() => {
          this.$router.push({ name: "Login" }).catch((err) => {
            console.warn("Navigation error:", err);
          });
        });
      });

      window.Echo.connector.pusher.connection.bind("connected", () => {
        this.$store.commit("updateOnline", true);
      });

      window.Echo.connector.pusher.connection.bind("unavailable", () => {
        //this.$store.commit('updateOnline', false);
      });
    });

    this.getLocations();

    this.getPositions();

    this.setupTimers();
  },
  methods: {
    setTemporary(role) {
      this.$bvModal.hide("role-select-modal");
      User.setTemporaryRole({ role: role }).then((response) => {
        this.$store.commit("updateUser", response.data);
        localStorage.setItem("user", JSON.stringify(response.data));
        this.$root.$emit("role-id-updated");
        //location.reload();
      });
    },
    logout() {
      if (hasPendingRequests()) {
        this.showOverlay = true; // Show overlay if requests are pending
        this.waitForRequestsToFinish();
      } else {
        this.performLogout();
      }
    },
    waitForRequestsToFinish() {
      const interval = setInterval(() => {
        if (!hasPendingRequests()) {
          clearInterval(interval); // Stop polling
          this.performLogout(); // Perform logout once requests are finished
        }
      }, 250); // Check every 250ms
    },
    performLogout() {
      this.$store.commit("updateLogoutInProgressInCurrentTab", true);
      const browserSessionId = localStorage.getItem("browser_session_id");

      User.logout({ browser_session_id: browserSessionId }).then(() => {
        this.$store.commit("updateAuth", false);
        this.$store.commit("updateUser", null);
        localStorage.removeItem("auth");
        localStorage.removeItem("user");
        this.$router.push({ name: "Login" });
        this.showOverlay = false; // Hide overlay after logout
      }).then(()=>{
        this.$store.commit("updateLogoutInProgressInCurrentTab", false);        
      });
    },
    toggleDarkMode() {
      this.$emit("darkmode-change", this.appOptions.appDarkMode);
    },
    toggleSidebarMobile() {
      this.appOptions.appSidebarMobileToggled =
        !this.appOptions.appSidebarMobileToggled;
    },
    toggleSidebarEnd() {
      this.appOptions.appSidebarEndToggled =
        !this.appOptions.appSidebarEndToggled;
    },
    toggleSidebarEndMobile() {
      this.appOptions.appSidebarEndMobileToggled =
        !this.appOptions.appSidebarEndMobileToggled;
    },
    toggleTopMenuMobile() {
      this.appOptions.appTopMenuMobileToggled =
        !this.appOptions.appTopMenuMobileToggled;
    },
    toggleHeaderMegaMenuMobile() {
      this.appOptions.appHeaderMegaMenuMobileToggled =
        !this.appOptions.appHeaderMegaMenuMobileToggled;
    },
    checkForm: function (e) {
      e.preventDefault();
      this.$router.push({ path: "/extra/search" });
    },
    handleInactive() {
      this.logout();
    },
    startTimer() {
      this.timeoutId = setTimeout(this.handleInactive, this.timeoutInMS);
    },
    resetTimer() {
      clearTimeout(this.timeoutId);
      this.startTimer();
    },

    setupTimers() {
      document.addEventListener("keypress", this.resetTimer, false);
      document.addEventListener("mousemove", this.resetTimer, false);
      document.addEventListener("mousedown", this.resetTimer, false);
      document.addEventListener("touchmove", this.resetTimer, false);

      this.startTimer();
    },
    closeDropdown() {
      this.$refs.bellDropdown.hide();
    },
    markAsRead(id) {
      let n =
        this.notifications[this.notifications.findIndex((e) => e.id == id)];
      if (!n.read_at) {
        User.markAsRead(id);
        n.read_at = true;
      }
    },
    getLocations() {
      Location.indexlinear().then((result) => {
        this.$store.commit("updateLocationsLinear", result.data);
      });
    },
    getPositions() {
      Position.index().then((result) => {
        this.$store.commit("updatePositions", result.data);
      });
    },
    alertClass(priority) {
      switch (priority) {
        case 1:
          return "alert-info";
        case 2:
          return "alert-warning";
        case 3:
          return "alert-danger";
        default:
          return "alert-info";
      }
    },
    getRandomInt(min, max) {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    closeModal(i) {
      if (i == this.randomIntForClose) {
        User.markSystemMessagesAsRead();
        this.$bvModal.hide("system-messages-modal");
      }
    },
  },
};
</script>

<style scoped>
/* Full-screen overlay */
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.75); /* 75% opacity black */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

/* Spinner */
.spinner {
  width: 50px;
  height: 50px;
  border: 6px solid #fff;
  border-top: 6px solid transparent;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
